/**
 * feedback.farsroute.com must only serve the public feedback UI —
 * never CRM login, dashboard, or other app routes.
 */

const OBJECT_ID_RE = /^[a-fA-F0-9]{24}$/

export function isFeedbackHost(hostname = window.location.hostname): boolean {
  const host = String(hostname || '').toLowerCase()
  return host === 'feedback.farsroute.com' || host.startsWith('feedback.')
}

/** Extract customer link ObjectId from a path like /id or /servary/id */
export function extractFeedbackLinkId(path: string): string | null {
  const clean = String(path || '').split('?')[0].replace(/\/+$/, '') || '/'
  const servary = clean.match(/^\/servary\/([a-fA-F0-9]{24})$/i)
  if (servary) return servary[1]
  const bare = clean.match(/^\/([a-fA-F0-9]{24})$/i)
  if (bare) return bare[1]
  return null
}

export function isFeedbackAllowedRouteName(name: unknown): boolean {
  return name === 'FeedbackPublic' || name === 'Servary' || name === 'FeedbackHome'
}

export { OBJECT_ID_RE }
